// import { combineReducers } from 'redux';

import { orderReducer } from '../domains/Order/store/slice';
import { UIReducer } from '../domains/UI/store/slice';

import { productReducer } from '../domains/Product/store/slice';
import { networkReducer } from '../domains/Network/store/slice';
import { accountReducer } from '../Account/state/store';
import authReducer from '../domains/Auth/slice';
import checkoutReducer from '../domains/Checkout/slice';

import { api as accountAPI } from '../Account/api';
import { api as authAPI } from '../Auth/api';

import { api as OAuthAPI } from '../Auth/api/oauth';

import ErrorsReducer from '../domains/Errors/slice';
import { combineReducers } from '@reduxjs/toolkit';

const rootReducer = combineReducers({
	checkoutReducer: checkoutReducer,
	orderReducer: orderReducer,
	uiReducer: UIReducer,
	productReducer: productReducer,
	networkReducer: networkReducer,
	accountReducer: accountReducer,
	authReducer: authReducer,
	[accountAPI.reducerPath]: accountAPI.reducer,
	[authAPI.reducerPath]: authAPI.reducer,
	[OAuthAPI.reducerPath]: OAuthAPI.reducer,
	ErrorsReducer: ErrorsReducer
});

export default rootReducer;
export type RootState = ReturnType<typeof rootReducer>;
